import { render, staticRenderFns } from "./DetalheOfertaGlobal.vue?vue&type=template&id=47897596&scoped=true"
import script from "./DetalheOfertaGlobal.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaGlobal.vue?vue&type=script&lang=js"
import style0 from "./DetalheOfertaGlobal.vue?vue&type=style&index=0&id=47897596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47897596",
  null
  
)

export default component.exports